import React from 'react'

export const FavoritesContext = React.createContext(null)
export const useFavorites = () => React.useContext(FavoritesContext)

export const useRegisterFavorite = (props) => {
    const ctx = useFavorites()
    const registerRef = React.useRef(null)
    registerRef.current = ctx?.registerField || null

    React.useEffect(() => {
        if (!registerRef.current || !props.favoritesGroupName || !props.favoritesFieldName) return

        // Regista o campo (usa ref para evitar loop infinito quando o contexto muda)
        const unsubscribe = registerRef.current(props.favoritesGroupName, props.favoritesFieldName, {
            label: props.label || props.favoritesFieldName,
            idKey: props.favoritesIdKey,
            varKey: props.favoritesVarKey,
            displayKey: props.favoritesDisplayKey,
            required: props.required || false
        })

        return unsubscribe
    }, [props.favoritesGroupName, props.favoritesFieldName, props.favoritesIdKey, props.favoritesVarKey, props.label, props.required])
}
